export const hasTouchSupport = () => {
  if (!process.client) return false;

  return "ontouchstart" in window || navigator.maxTouchPoints > 0;
};
